import { constantRoutes } from '@/router'
// import { post } from '@/utils/request'

import Layout from '@/layout'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.Meta) {
    return roles.some(role => route.Meta.roles.includes(role))
  } else {
    return true
  }
}
function getViews(path) {
  return resolve => {
    // eslint-disable-next-line no-undef
    require.ensure([], (require) => {
      resolve(require('@/' + path + '/index.vue'))
    })
  }
}
/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.component === 'layout') {
        tmp.component = Layout
      } else {
        tmp.component = getViews(tmp.component)
      }
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })
  return res
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({ commit }, roles) {
    return new Promise(async resolve => {
      let accessedRoutes = []
      let asyncRoutes = []
      // await post('/baPerPermission/getMenuListInformation').then(response => {
      //   asyncRoutes = response.data
      // })
      asyncRoutes = [
        {
          'id': '180000',
          'parentId': '0',
          'path': '',
          'meta': {
            'roles': [
              'admin'
            ],
            'title': '客户案例',
            'englishTitle': 'Equipment Alarm Inquiry'
          },
          'component': 'layout',
          'alwaysShow': 0,
          'sortOrder': 69,
          'children': [
            {
              'id': '180101',
              'parentId': '180000',
              'path': '/Customer_case_list',
              'meta': {
                'roles': [
                  'admin'
                ],
                'title': '客户案例',
                'englishTitle': 'Planned Management'
              },
              'component': 'views/Customer_case_list',
              'alwaysShow': 0,
              'sortOrder': 35
            }
          ]
        },
        {
          'id': '180001',
          'parentId': '0',
          'path': '',

          'meta': {
            'roles': [
              'admin'
            ],
            'title': '联系我们',
            'englishTitle': 'Contact'
          },
          'component': 'layout',
          'alwaysShow': 0,
          'sortOrder': 69,
          'children': [
            {
              'id': '180101',
              'parentId': '180000',
              'path': '/contact_us',
              'meta': {
                'roles': [
                  'admin'
                ],
                'icon': null,
                'title': '联系我们',
                'englishTitle': 'Contact'
              },
              // 更换组件
              'component': 'views/contact_us',
              'alwaysShow': 0,
              'sortOrder': 35
            }
          ]
        },
        {
          'id': '180003',
          'parentId': '0',
          'path': '',

          'meta': {
            'roles': [
              'admin'
            ],
            'title': '行业咨询',
            'englishTitle': 'Industry Advice'
          },
          'component': 'layout',
          'alwaysShow': 0,
          'sortOrder': 69,
          'children': [
            {
              'id': '180101',
              'parentId': '180000',
              'path': '/industry_advice',
              'meta': {
                'roles': [
                  'admin'
                ],
                'icon': null,
                'title': '行业咨询',
                'englishTitle': 'Industry Advice'
              },
              // 更换组件
              'component': 'views/industry_advice',
              'alwaysShow': 0,
              'sortOrder': 35
            }
          ]
        },
        {
          'id': '180004',
          'parentId': '0',
          'path': '',

          'meta': {
            'roles': [
              'admin'
            ],
            'title': '行业详情',
            'englishTitle': 'Industry Detail'
          },
          'component': 'layout',
          'alwaysShow': 0,
          'sortOrder': 69,
          'children': [
            {
              'id': '180101',
              'parentId': '180000',
              'path': '/industry_menu_detail',
              'meta': {
                'roles': [
                  'admin'
                ],
                'icon': null,
                'title': '行业详情',
                'englishTitle': 'Industry Detail'
              },
              // 更换组件
              'component': 'views/industry_menu_detail',
              'alwaysShow': 0,
              'sortOrder': 35
            }
          ]
        },
        {
          'id': '180005',
          'parentId': '0',
          'path': '',

          'meta': {
            'roles': [
              'admin'
            ],
            'title': '公司新闻',
            'englishTitle': 'Company News'
          },
          'component': 'layout',
          'alwaysShow': 0,
          'sortOrder': 69,
          'children': [
            {
              'id': '180101',
              'parentId': '180005',
              'path': '/Company_news',
              'meta': {
                'roles': [
                  'admin'
                ],
                'icon': null,
                'title': '公司新闻',
                'englishTitle': 'Company News'
              },
              // 更换组件
              'component': 'views/company_news',
              'alwaysShow': 0,
              'sortOrder': 35
            }
          ]
        },
        {
          'id': '180006',
          'parentId': '0',
          'path': '',

          'meta': {
            'roles': [
              'admin'
            ],
            'title': '反馈信息',
            'englishTitle': 'Feed Back'
          },
          'component': 'layout',
          'alwaysShow': 0,
          'sortOrder': 69,
          'children': [
            {
              'id': '180101',
              'parentId': '180000',
              'path': '/feed_back',
              'meta': {
                'roles': [
                  'admin'
                ],
                'icon': null,
                'title': '反馈信息',
                'englishTitle': 'Feed Back'
              },
              // 更换组件
              'component': 'views/feed_back',
              'alwaysShow': 0,
              'sortOrder': 35
            }
          ]
        },
        {
          'id': '180007',
          'parentId': '0',
          'path': '',

          'meta': {
            'roles': [
              'admin'
            ],
            'title': '职位信息',
            'englishTitle': 'Jobs'
          },
          'component': 'layout',
          'alwaysShow': 0,
          'sortOrder': 69,
          'children': [
            {
              'id': '180101',
              'parentId': '180007',
              'path': '/jobs',
              'meta': {
                'roles': [
                  'admin'
                ],
                'icon': null,
                'title': '职位信息',
                'englishTitle': 'Jobs'
              },
              // 更换组件
              'component': 'views/jobs',
              'alwaysShow': 0,
              'sortOrder': 35
            }
          ]
        },{
          'id': '180008',
          'parentId': '0',
          'path': '',

          'meta': {
            'roles': [
              'admin'
            ],
            'title': '解决方案',
            'englishTitle': 'Solution'
          },
          'component': 'layout',
          'alwaysShow': 0,
          'sortOrder': 69,
          'children': [
            {
              'id': '180101',
              'parentId': '180008',
              'path': '/Solution',
              'meta': {
                'roles': [
                  'admin'
                ],
                'icon': null,
                'title': '解决方案',
                'englishTitle': 'Solution'
              },
              // 更换组件
              'component': 'views/solution',
              'alwaysShow': 0,
              'sortOrder': 35
            }
          ]
        },{
          'id': '180009',
          'parentId': '0',
          'path': '',

          'meta': {
            'roles': [
              'admin'
            ],
            'title': '免费体验',
            'englishTitle': 'Free'
          },
          'component': 'layout',
          'alwaysShow': 0,
          'sortOrder': 69,
          'children': [
            {
              'id': '180101',
              'parentId': '180009',
              'path': '/Free',
              'meta': {
                'roles': [
                  'admin'
                ],
                'icon': null,
                'title': '免费体验',
                'englishTitle': 'Free'
              },
              // 更换组件
              'component': 'views/free',
              'alwaysShow': 0,
              'sortOrder': 35
            }
          ]
        }]
      accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)

      // 将路由信息，菜单信息，用户信息存到sessionStorage里
      sessionStorage.setItem('routes', JSON.stringify(accessedRoutes))
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js